import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import TestimonialTwo from '../testimonial/TestimonialTwo';
import SectionTitle from '../sectionTitle/SectionTitle';

const TestimonialSectionOne = ({testimonials}) => {
    
    return (
        <div className="eduvibe-home-four-testimonial edu-testimonial-area edu-section-gap bg-color-white">
            <div className="container eduvibe-animated-shape">
                <div className="row">
                    <div className="col-lg-6">
                        <ScrollAnimation 
                            animateIn="fadeIn"
                            animateOut="fadeInOut"
                            className="testimonial-left-image pr--80"
                            animateOnce={ true }
                        >
                            <div className="thumbnail">
                                <div className="circle-image-wrapper">
                                    <img className="radius-round-5" src="/images/testimonial-section/client-01.jpg" alt="Testimonial Section Thumb" />
                                    <div className="circle-image">
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                    <div className="col-lg-6">
                        <div className="testimonial-wrapper">
                            <SectionTitle
                                classes = "text-start mb--40"
                                slogan = "Testimonial"
                                title = "Our Clients Feedback"
                            />
                            <TestimonialTwo testimonials={testimonials} />
                        </div>
                    </div>
                </div>

                
            </div>
        </div>
    )
}

export default TestimonialSectionOne;